import { fromIsoString, toIsoString } from '../chat/iso-date';
import type { WorkflowEdgeData } from './types';
import type { SerializedWorkflowEdge } from './types';

/**
 * Directed edge between two nodes (`workflow_edges`).
 */
export class WorkflowEdge {
  private readonly _data: WorkflowEdgeData;

  private constructor(data: WorkflowEdgeData) {
    this._data = data;
  }

  get id(): string {
    return this._data.id;
  }

  get ownerId(): string {
    return this._data.ownerId;
  }

  get ownerOrgId(): string {
    return this._data.ownerOrgId;
  }

  get workflowId(): string {
    return this._data.workflowId;
  }

  get fromNodeId(): string {
    return this._data.fromNodeId;
  }

  get toNodeId(): string {
    return this._data.toNodeId;
  }

  get condition(): unknown {
    return this._data.condition;
  }

  get createdAt(): Date {
    return this._data.createdAt;
  }

  get updatedAt(): Date {
    return this._data.updatedAt;
  }

  get edgeData(): WorkflowEdgeData {
    return { ...this._data };
  }

  serialize(): SerializedWorkflowEdge {
    return {
      id: this._data.id,
      ownerId: this._data.ownerId,
      ownerOrgId: this._data.ownerOrgId,
      workflowId: this._data.workflowId,
      fromNodeId: this._data.fromNodeId,
      toNodeId: this._data.toNodeId,
      condition: this._data.condition,
      createdAt: toIsoString(this._data.createdAt),
      updatedAt: toIsoString(this._data.updatedAt),
    };
  }

  static fromSerialized(serialized: SerializedWorkflowEdge): WorkflowEdge {
    const data: WorkflowEdgeData = {
      id: serialized.id,
      ownerId: serialized.ownerId,
      ownerOrgId: serialized.ownerOrgId,
      workflowId: serialized.workflowId,
      fromNodeId: serialized.fromNodeId,
      toNodeId: serialized.toNodeId,
      condition: serialized.condition,
      createdAt: fromIsoString(serialized.createdAt),
      updatedAt: fromIsoString(serialized.updatedAt),
    };
    return new WorkflowEdge(data);
  }
}
